var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomAdvice = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.868 10.336h-.674v7.404c0 1.153-.67 2.195-2.016 2.195H8.994v.352c0 1.02 1.16 2.048 2.35 2.048h10.08l3.855 2.267-.559-2.267h.148c1.19 0 1.726-1.026 1.726-2.048v-8.193c0-1.02-.536-1.758-1.726-1.758z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.21 5.192H4.898C3.55 5.192 2 6.389 2 7.542v9.28c0 1.063 1.314 1.83 2.574 1.948l-.82 3.113 5.254-3.091H20.21c1.347 0 2.59-.817 2.59-1.97v-9.28c0-1.153-1.244-2.35-2.59-2.35zM7.234 13.026a1.383 1.383 0 1 1 0-2.767 1.383 1.383 0 0 1 0 2.767zm5.166 0a1.383 1.383 0 1 1 0-2.767 1.383 1.383 0 0 1 0 2.767zm5.167 0a1.384 1.384 0 1 1 0-2.768 1.384 1.384 0 0 1 0 2.768z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomAdvice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-advice.ffbe7b65581cd26465204e9b423e31ce.svg";